<template>
  <b-navbar
    toggleable="md"
    type="dark"
    variant="dark">
    <b-navbar-toggle target="nav_dropdown_collapse" />

    <b-collapse
      id="nav_dropdown_collapse"
      is-nav>
      <b-navbar-nav>
        <template
          v-for="route in routes"
          :to="route.path">
          <router-link
            :key="route.name"
            :to="route.path"
            class="nav-item"
            tag="li">
            <a class="nav-link">
              {{ route.meta.navigation }}
            </a>
          </router-link>
        </template>

        <template>
          <b-nav-item-dropdown text="Settings">
            <router-link
              v-for="section in sections"
              :key="section.key"
              :to="`/settings/${section.key}`"
              class="dropdown-item">
              {{ section.name }}
            </router-link>
          </b-nav-item-dropdown>
        </template>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using button-content slot -->
          <template slot="button-content">
            User
          </template>
          <router-link
            to="/profile"
            class="dropdown-item">
            Profile
          </router-link>
          <b-dropdown-item
            href="#"
            @click.prevent="logout">
            Signout
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import sortBy from 'lodash-es/sortBy';
import { mapState, mapActions } from 'vuex';
import { FETCH_SECTIONS } from '../settings/store';

export default {

  name: 'Navbar',

  computed: {
    routes() {
      return sortBy(
        this.$router.options.routes
          .filter(route => route.meta && route.meta.navigation),
          (route => route.meta.order),
      );
    },

    ...mapState('settings', {
      sections: state => state.sections
    })
  },

  created() {
    this.fetchSections()
  },

  /**
     * The methods that the layout can use.
     */
  methods: {
    /**
       * Will log the user out.
       */
    logout() {
      this.$store.dispatch('auth/logout');
    },

    ...mapActions('settings', [FETCH_SECTIONS])
  }
};
</script>
<style>
#nav_dropdown_collapse > ul{
  flex-wrap: wrap;
}
</style>
